import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  getDashboard(date) {
    return this.http.get(this.api+`/dashboard?data=${date}`);
  }
}
